<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'StartEndTimeFilter',
  mixins: [baseMixin],
  props: {
    localTime: { type: String, default: null },
    localTime2: { type: String, default: null },
    filterScrollAreaHeight: { type: Number, default: 0 },
    filterTime1: { type: Boolean, default: false },
    filterTime2: { type: Boolean, default: false },
  },
  data() {
    return {
      tempStartTime: this.localTime,
      tempEndTime: this.localTime2,
      internalTime: this.localTime,
      internalTime2: this.localTime2,
      internalFilterTime1: this.filterTime1,
      internalFilterTime2: this.filterTime2,
    }
  },
  watch: {
    // parent -> child
    localTime(val) {
      this.internalTime = val
    },
    localTime2(val) {
      this.internalTime2 = val
    },
    filterTime1(val) {
      this.internalFilterTime1 = val
    },
    filterTime2(val) {
      this.internalFilterTime2 = val
    },

    // child -> parent
    internalTime(val) {
      this.$emit('update:localTime', val)
    },
    internalTime2(val) {
      this.$emit('update:localTime2', val)
    },
    internalFilterTime1(val) {
      this.$emit('update:filterTime1', val)
    },
    internalFilterTime2(val) {
      this.$emit('update:filterTime2', val)
    },
  },
  methods: {
    closeTimePicker(which) {
      if (which === 'start') {
        this.internalTime = this.tempStartTime
        this.internalFilterTime1 = false
      }
      if (which === 'end') {
        this.internalTime2 = this.tempEndTime
        this.internalFilterTime2 = false
      }
    },
  },
}
</script>

<template>
  <div
    class="filter-panel"
    :style="{ maxHeight: `${filterScrollAreaHeight + 109}px` }"
  >
    <div class="filter-title d-flex align-center mb-4">
      <v-icon size="20" class="me-2 cursor-pointer" @click.stop="$emit('back')">
        mdi-arrow-left
      </v-icon>
      <span class="filter-header">{{
        $t('bookingList.headerName.startEndTime')
      }}</span>
    </div>

    <div ref="filterContainerBox" class="filter-container-box">
      <div class="filter-scrollable">
        <div class="timer-area">
          <!-- Start Time -->
          <v-col cols="12">
            <v-menu
              ref="menu"
              v-model="internalFilterTime1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="150px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="internalTime"
                  label="Start"
                  placeholder="00:00 AM"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="internalFilterTime1"
                v-model="tempStartTime"
                :max="tempEndTime"
                full-width
              >
                <v-spacer></v-spacer>
                <BaseButton
                  :border-radius="'8px'"
                  :width="'100%'"
                  :height="'30px'"
                  class="p-5 apply-btn"
                  @click="closeTimePicker('start')"
                >
                  {{ $t('general.done') }}
                </BaseButton>
              </v-time-picker>
            </v-menu>
          </v-col>

          <!-- End Time -->
          <v-col cols="12">
            <v-menu
              ref="menu2"
              v-model="internalFilterTime2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="150px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="internalTime2"
                  label="End"
                  placeholder="00:00 AM"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="internalFilterTime2"
                v-model="tempEndTime"
                :min="tempStartTime"
                full-width
              >
                <v-spacer></v-spacer>
                <BaseButton
                  :border-radius="'8px'"
                  :width="'100%'"
                  :height="'30px'"
                  class="p-5 apply-btn"
                  @click="closeTimePicker('end')"
                >
                  {{ $t('general.done') }}
                </BaseButton>
              </v-time-picker>
            </v-menu>
          </v-col>
        </div>
      </div>
    </div>

    <div class="filter-footer">
      <div class="d-flex align-center justify-space-between w-100">
        <div class="flex-grow-1">
          <div
            v-show="internalTime || internalTime2"
            class="cursor-pointer clear-filter"
            :class="colorClass.text.primary400"
            @click="$emit('clear')"
          >
            {{ $t('topFilterBar.filter.clearAll') }}
          </div>
        </div>
        <BaseButton
          :border-radius="'8px'"
          :width="'70px'"
          :height="'30px'"
          class="p-5 apply-btn"
          :disabled="!internalTime && !internalTime2"
          @click.stop="$emit('apply')"
        >
          {{ $t('apply') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>
